var _defs, _path, _path2, _rect, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .viewA {\n                opacity: 0;\n            }\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168.6,390.606h0a4.611,4.611,0,1,0,4.5,4.609A4.56,4.56,0,0,0,168.6,390.605Zm0,8.207a3.557,3.557,0,0,1-3.509-3.6,3.6,3.6,0,0,1,1.012-2.535,3.441,3.441,0,0,1,2.07-1.035v-.025l.428,0a3.6,3.6,0,0,1,0,7.192Z",
    transform: "translate(-156.726 -383.078)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M167.366,387.727h-.014l-.265,0a13.813,13.813,0,0,0-11.529,6.844.575.575,0,0,0,0,.576c2.759,4.381,7.153,6.939,11.79,6.846a13.837,13.837,0,0,0,11.807-6.853.56.56,0,0,0,0-.574C176.394,390.183,171.985,387.611,167.366,387.727Zm10.7,7.412a12.8,12.8,0,0,1-10.715,5.838l-.22,0a12.858,12.858,0,0,1-10.483-5.84l-.2-.28.2-.28a12.879,12.879,0,0,1,10.7-5.837h0a12.83,12.83,0,0,1,10.715,5.836l.2.28Z",
    transform: "translate(-155.483 -382.724)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "viewA",
    width: 24,
    height: 24,
    transform: "translate(0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "viewA",
    width: 23.754,
    height: 23.754,
    transform: "translate(0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view-icon.ff2183b9.svg";
export { ForwardRef as ReactComponent };